module.exports = __webpack_public_path__ + "img/marker-radius.20194535.svg";